/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileOutgoingRequest, MobileTicket } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class MobileApprovalsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-approvals-controller
   * @name GetMobileTicketByTicketId
   * @request GET:/api/m/workflow/ticket/{ticketId}
   */
  getMobileTicketByTicketId = (ticketId: string, params: RequestParams = {}) =>
    this.http.request<MobileTicket, any>({
      path: `/m/workflow/ticket/${ticketId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMobileTicketByTicketIdPath = '/m/workflow/ticket/${ticketId}'
  static getMobileTicketByTicketIdMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-approvals-controller
   * @name GetMobileOutgoingRequestByTicketId
   * @request GET:/api/m/workflow/request/{ticketId}
   */
  getMobileOutgoingRequestByTicketId = (ticketId: string, params: RequestParams = {}) =>
    this.http.request<MobileOutgoingRequest, any>({
      path: `/m/workflow/request/${ticketId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMobileOutgoingRequestByTicketIdPath = '/m/workflow/request/${ticketId}'
  static getMobileOutgoingRequestByTicketIdMethod = 'GET'
}
